module.exports = __webpack_public_path__ + "img/aws-certified-solutions-architect-associate-90x90.6907b260.png";